export default "__VITE_ASSET__Wg9kG6Aw__"